
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import { version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import MainMenuConfig from "@/core/config/MainMenuConfig";
import { userGuard } from "@/store/utils/userGourad";
import store from "@/store";

export default defineComponent({
  name: "kt-menu",
  components: {},
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const scrollElRef = ref<null | HTMLElement>(null);

    onMounted(() => {
      ScrollComponent.reinitialization();
      MenuComponent.reinitialization();
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    const MenuItemList = ref([]);

    const mapMainMenuConfig = () => {
      let userInfo = store.getters["AuthModule/_getUser"];

      var list = MainMenuConfig.filter((item) => {
        let x = item.pages.filter((page) => {
          let status = true;
          if (page.permissions !== undefined) {
            status = userInfo.PermissionNames.some(
              (i) => i === page.permissions
            );
          }

          return status;
        });

        return x.length > 0;
      });
      MenuItemList.value = JSON.parse(JSON.stringify(list));
    };
    mapMainMenuConfig();
    return {
      hasActiveChildren,
      MenuItemList,
      asideMenuIcons,
      version,
      translate,
      userGuard,
    };
  },
});
